import { render, staticRenderFns } from "./nianshenru.vue?vue&type=template&id=b5122fbe&"
import script from "./nianshenru.vue?vue&type=script&lang=js&"
export * from "./nianshenru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports